<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-5">
        <sales-order-subsidized-invoice-mail-form
          :salesOrder="salesOrder"
          :toggleMailModal="toggleMailModal"
          :alreadySent="alreadySent"
          @sent="$emit('sent')"
        />
      </div>
      <div class="col-12 col-md-7" style="max-height: 100%">
        <sales-order-view-details
          :showHeader="false"
          :salesOrder="salesOrder"
          @salesOrderItemsUpdated="get"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <el-button type="danger" @click="toggleMailModal">
        {{ $t("COMMON.CANCEL") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { Button } from "element-ui";
import salesOrderViewDetails from "./SalesOrderViewDetails.vue";
import SalesOrderSubsidizedInvoiceMailForm from "./SalesOrderSubsidizedInvoiceMailForm.vue";

export default {
  layout: "DashboardLayout",
  name: "sales-order-subsidized-invoice-mail-modal-content",

  components: {
    SalesOrderSubsidizedInvoiceMailForm,
    [Button.name]: Button,
    salesOrderViewDetails,
  },

  props: {
    salesOrder: {
      default: () => ({}),
    },
    toggleMailModal: {
      type: Function,
    },
    get: {
      type: Function,
    },
    alreadySent: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
